import {formatPhoneNumber, getAppliedMask} from '@logistics-frontend/core/formatters'
import React, {useCallback, useMemo, useState} from 'react'

import Input from './Input'
import {PhoneInputComponentProps} from './types'

export const PhoneInput: React.FC<React.PropsWithChildren<PhoneInputComponentProps>> = ({
  value = '',
  formatChars,
  int18Masks,
  localMasks,
  phoneCode,
  onChange,
  onFocus,
  ...otherProps
}) => {
  const [plus, setPlus] = useState('')
  const int18PhoneCode = value === '' && phoneCode ? phoneCode : undefined
  const maskData = getAppliedMask(value, int18Masks, localMasks)
  const maxLength = maskData?.mask?.split('').filter(ch => ch === '#').length

  const formatedPhoneNumber = useMemo(
    () => formatPhoneNumber(plus + value, formatChars, int18Masks, localMasks),
    [plus, value, formatChars, int18Masks, localMasks],
  )

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const input: string = e.target.value

      setPlus(input[0] === '+' ? input[0] : '')
      const numericValue = input.replace(/\D/g, '')
      //FIXME: очень костыльно, но работает, пока нет нормального инпута для телефонов CARGODEV-17788
      if (maxLength && numericValue.length > maxLength) {
        return
      }
      e.target.value = numericValue
      onChange && onChange(e)
    },
    [maxLength, onChange],
  )

  const focusHandler = useCallback(
    e => {
      if (int18PhoneCode) {
        const codeWithPlus = `+${int18PhoneCode}`

        e.target.value = int18PhoneCode
        onChange(e)
        window.requestAnimationFrame(() => {
          e.target.selectionStart = codeWithPlus.length
          e.target.selectionEnd = codeWithPlus.length
        })
      }
      onFocus(e)
    },
    [int18PhoneCode, onFocus, onChange],
  )

  return <Input {...otherProps} onChange={handleChange} onFocus={focusHandler} value={formatedPhoneNumber} />
}

export default PhoneInput
